/* eslint-disable import/prefer-default-export */
export const STATE_QUERY_PARAM = 'state';
